//#!if iOS === true
// import "./formSwitch.scss";
//#!endif
import "./form.scss";

import PropTypes from "prop-types";
import React, { Fragment, PureComponent } from "react";

import CheckboxStates from "../../constants/checkboxStates";
import KeyConstants from "../../constants/keyConstants";
import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import HelpIcon from "../interface/HelpIcon";
import Icon from "../interface/Icon";

const toCheckboxState = propState =>
  propState === true ? CheckboxStates.CHECKED : !propState ? CheckboxStates.UNCHECKED : propState;

const stateToBoolean = newState => newState === CheckboxStates.CHECKED;

export default class FormCheckbox extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = { checkboxState: CheckboxStates.UNCHECKED };
    this.toggle = this.toggle.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.focus = this.focus.bind(this);
  }

  componentWillMount() {
    this.setState({ checkboxState: toCheckboxState(this.props.checkboxState) });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ checkboxState: toCheckboxState(nextProps.checkboxState) });
  }

  onKeyDown(e) {
    if (e.key === KeyConstants.Space && !this.props.disabled) {
      e.stopPropagation();
      e.preventDefault();
      this.toggle();
    }
  }

  toggle() {
    const newState =
      this.state.checkboxState === CheckboxStates.CHECKED ? CheckboxStates.UNCHECKED : CheckboxStates.CHECKED;
    this.setState({ checkboxState: newState });
    // Make output format match the input format specified by props.
    const outState = stateToBoolean(newState);
    this.props.onChange(outState);
  }

  focus() {
    if (!this.props.disabled && this._domNode) {
      this._domNode.focus();
    }
  }

  render() {
    const stateClass =
      this.state.checkboxState === CheckboxStates.CHECKED
        ? "checked"
        : this.state.checkboxState === CheckboxStates.MIXED
          ? "mixed"
          : "";

    const classes = [
      "formCheckbox",
      stateClass,
      this.props.disabled ? "disabled" : "",
      this.props.label ? "" : "noLabel",
      this.props.className ? this.props.className : ""
    ];

    const divGraphic =
      !this.props.isCheckboxStyle && preprocessorQuery.isIos() ? (
        <div className="form-switch">
          <span>{this.props.label}</span>
          <i />
        </div>
      ) : (
        <Fragment>
          <Icon icon={this.state.checkboxState === CheckboxStates.MIXED ? "checkboxMixed" : "checkboxTick"} />
          {this.props.label}
          {this.props.helpTooltip ? <HelpIcon tooltip={this.props.helpTooltip} /> : null}
        </Fragment>
      );

    return (
      <div
        ref={node => (this._domNode = node)}
        className={classes.join(" ")}
        onClick={this.props.disabled ? null : this.toggle}
        tabIndex={this.props.disabled ? null : 0}
        onKeyDown={this.onKeyDown}
        onFocus={this.focus}
      >
        {divGraphic}
      </div>
    );
  }
}

FormCheckbox.propTypes = {
  label: PropTypes.string,
  // User can either specify a boolean value (true=checked, false=unchecked), or one of the CheckboxStates
  checkboxState: PropTypeShapes.checkboxState,
  disabled: PropTypes.bool,
  // onChange function will be called with the value converted to true/false (i.e. isChecked)
  onChange: PropTypes.func,
  isCheckboxStyle: PropTypes.bool,
  helpTooltip: PropTypes.string,
  className: PropTypes.string
};
